/* eslint-disable react/no-unescaped-entities */
import React, { useMemo, useState } from 'react';
import s from './s.module.less';
// import { StepValue } from 'pages/CreateUniProfilePage/types';
// import ProviderStore from 'store/Provider';
import { NoticeType } from 'antd/es/message/interface';
import globalFormsEditStatusStore from 'store/ChannelApplicationProvider/FormsEditStatus';
import {
    EProviderType,
    ProviderLicenseFromDataWithoutState,
    ProviderProfile,
    ServiceExt,
    UniprofileFormData,
} from 'types/provider';
import Landing from './components/Landing';
import ServiceModal from './components/ServiceModal';
import ServiceTable from './components/ServiceTable';
import {
    EContactType,
    KlarityService,
    KlarityServiceTypeInfo,
    ServerMeta,
    ELicenseType,
    TKlarityServiceServerTableItem,
    TKlarityServiceUiTableItem,
    ServerKlarityService,
    TKlarityProgramItem,
} from 'types/common';
import { EModalMode } from './types';
import useGetSettingData from 'hooks/useGetSettingData';
import { EnumFields, SettingEnum } from 'types/enumerationData';
import { FormLicense } from 'types/form';
import useKlarityServiceTemplate from 'hooks/useKlarityServiceTemplate';
import { getProviderSpecialtyDetail, getSpecialityTemplateDetail } from 'api/klarityService';
import { getOpsProviderSpecialtyDetail, getOpsSpecialityTemplateDetail } from 'api/operation';
import useProviderKlarityServiceList from 'hooks/useProviderKlarityServiceList';
import { Modal, Spin } from 'antd';
import { PracitceAddressForm } from 'types/practiceFront';
import ServiceLayer from './components/ServiceLayer';
import { setConfigingProgramId, setConfigProgramFromTable } from 'utils/sessionStorage';
import commonS from 'styles/common.module.less';
import { LA_FIRE_SPE_NAME, LA_WILD_FIRE_SPECIALTY_NAME } from 'constants/common';
import { remove } from 'lodash';
import { getUrlParam, removeSpecialCharsFromStartAndEnd } from 'utils/common';
import { IInsurance } from 'types/insurance';
import UniprofileStepDataStore from 'store/UniprofileStepData';
import useKlarityProgram from 'hooks/useKlarityProgram';
import useGetSpecialtiesAndConditions from 'hooks/useGetSpecialtiesAndConditions';

interface IProps {
    licenses?: ProviderLicenseFromDataWithoutState;
    addressList?: PracitceAddressForm[];
    isReviewStep?: boolean;
    isOps?: boolean;
    // 运营端需要传当前操作的用户id
    providerId?: number;
    // showTypeCheckbox?: boolean;
    showEditButtons?: boolean;
    initFormValue?: Array<ServiceExt>;
    refetch?: () => void;
    // onSubmit: (data: ISubmitChannelRelationshipData, ste: StepValue) => void;
    onShowMessage?: (type: NoticeType, content: string) => void;
    setDisallowNext?: (disallow: boolean) => void;
    setDisallowNextTips?: (tips: string) => void;
    showSyncButton?: boolean;
    onClickSync?: () => void;
    checkTargetSpecialty?: boolean;
    providerType?: EProviderType;
    uniprofileInsuranceData?: IInsurance[];
    provider?: UniprofileFormData;
    // 下面2个props组合使用，用于Service设置页面，因为Service setting首次是先选择，最后进入table页面
    isServiceSetting?: boolean;
    settingIsDone?: boolean;
    layerNextBtnText?: string;
    layerFootWrapClass?: string;
    onLayerBackClick?: () => void;
    setCurrentStep?: (v: EModalMode) => void;
    hideAvaTip?: boolean;
    setIsSpecialtyiesEnd?: (v: boolean) => void;
    onSaveSuccessfully?: () => void;
    fullWidthFooter?: boolean;
    isPPVOPS?: boolean;
}
const KlarityServices = ({
    providerType,
    licenses,
    isReviewStep,
    isOps,
    providerId,
    showEditButtons = true,
    initFormValue = [],
    refetch,
    onShowMessage,
    setDisallowNext,
    setDisallowNextTips,
    addressList,
    showSyncButton,
    onClickSync,
    checkTargetSpecialty,
    uniprofileInsuranceData,
    provider,
    isServiceSetting,
    settingIsDone,
    layerNextBtnText = 'Next',
    layerFootWrapClass = '',
    onLayerBackClick,
    setCurrentStep,
    hideAvaTip,
    setIsSpecialtyiesEnd,
    onSaveSuccessfully,
    fullWidthFooter,
    isPPVOPS,
}: IProps) => {
    const [get, set] = UniprofileStepDataStore.useStore();
    const [showProgramNoteModal, setShowProgramNoteModal] = useState(false);
    const [editStatus, setEditStatus] = useState(false);
    const [getGlobalEditStatus, setGloalEditStatus] = globalFormsEditStatusStore.useStore();
    const [allStates] = useGetSettingData(EnumFields.STATE);
    const [licenseStates, setLicenseStates] = useState<ServerMeta[]>([]);
    const [editingData, setEditingData] = useState<KlarityService[]>([]);

    const [modalMode, setModalMode] = useState<EModalMode>(EModalMode.SELECT_SPECIALTY);
    const [template, loadingTemplate, refetchTemplate] = useKlarityServiceTemplate(isOps, providerId);

    const [fetchingEdit, setFetchingEdit] = useState(false);
    const [editSpecialityValue, setEditSpecialityValue] = useState<ServerKlarityService[]>();

    const [isEdit, setIsEdit] = useState(false);

    const [tableData, tableDataLoading, refetchTableData] = useProviderKlarityServiceList(isOps, providerId);

    const [showSelectModal, setShowSelectModal] = useState(false);
    const [showSelectLayer, setShowSelectLayer] = useState(false);
    const isKiwiUser = providerType === EProviderType.KIWI;
    const showLanding =
        !isKiwiUser && !isReviewStep && !isOps && tableData && tableData.length === 0 && !showSelectLayer;

    // 2025-4-8 service改成和klarity service一样的，所以流程从原来的页面中的serviceLayer改成现在的ServiceModal中的serviceLayer
    // 这就导致serverModal中的onServerIdStateMapChange设置的serverIdStateMap在ServiceLayer中的configService获取不到
    // 所以将setServerIdStateMap提升到这里来
    const [serverIdStateMap, setServerIdStateMap] = useState<Record<string, ServerMeta[]>>({});

    const targetSpecialty = checkTargetSpecialty ? getUrlParam('specialty') : undefined;

    const [allPrograms, klarityProgramloading, refetchProgram] = useKlarityProgram(isOps, providerId);

    const loading = tableDataLoading || tableData === undefined || klarityProgramloading || loadingTemplate;

    //const showLanding = false;
    const onClickReview = () => {
        if (isOps) {
            setShowSelectModal(true);
        } else {
            //setShowSelectModal(true);
            setShowSelectLayer(true);
        }
    };

    const templateDataFiltered = useMemo(() => {
        let recommend: KlarityService[] = [];
        let other: KlarityService[] = [];
        if (isKiwiUser && template) {
            recommend = template?.recommend.filter((r) => {
                // const program = allPrograms?.find((item) => item.specialtyName === r.specialtyName);
                // const isNotProgram = !program;
                // return isNotProgram;
                return true;
            });
            other = template?.other.filter((o) => {
                // const program = allPrograms?.find((item) => item.specialtyName === o.specialtyName);
                // const isNotProgram = !program;
                // return isNotProgram;
                return true;
            });
        } else {
            recommend = template?.recommend || [];
            other = template?.other || [];
        }
        return {
            recommend,
            other,
        };
    }, [template, allPrograms, isKiwiUser]);

    const practiceLicLength = licenses?.[ELicenseType.PRACTICE]?.length || 0;
    let targetSpecialtyHasConfig = false;
    if (tableData && tableData.length > 0 && targetSpecialty) {
        const find = tableData.find(
            (item) => item.serviceSpecialtyName?.toLowerCase() === targetSpecialty?.toLowerCase(),
        );
        if (find) {
            targetSpecialtyHasConfig = true;
        }
    }

    React.useEffect(() => {
        if (!isReviewStep && targetSpecialty && !targetSpecialtyHasConfig && tableData) {
            setShowSelectLayer(true);
        }
    }, [isReviewStep, targetSpecialty, targetSpecialtyHasConfig, tableData]);

    React.useEffect(() => {
        if (isServiceSetting) {
            setShowSelectLayer(!settingIsDone);
        }
    }, [isServiceSetting, settingIsDone]);

    React.useEffect(() => {
        if (!licenses) {
            return;
        }
        //const deaLicense = licenses[ELicenseType.DEA];
        const practiceLicense = licenses[ELicenseType.PRACTICE];
        const stateKeys: string[] = [];
        // deaLicense?.forEach((license:FormLicense) => {
        //     if (!stateKeys.includes(license.state)) {
        //         stateKeys.push(license.state);
        //     }
        // });
        practiceLicense?.forEach((license: FormLicense) => {
            if (!stateKeys.includes(license.state)) {
                stateKeys.push(license.state);
            }
        });

        const _licenseStates = (allStates as ServerMeta[])?.filter((state: ServerMeta) =>
            stateKeys.includes(state.dictKey),
        );

        setLicenseStates(_licenseStates || []);
    }, [allStates, licenses, practiceLicLength]);

    React.useEffect(() => {
        if (showLanding || showSelectLayer) {
            setDisallowNext?.(true);
            setDisallowNextTips?.('Please set up your Klarity ServIce and Programs to proceed.');
        } else {
            setDisallowNext?.(false);
        }
    }, [showLanding, showSelectLayer]);

    React.useEffect(() => {
        return () => {
            setDisallowNext?.(false);
            setDisallowNextTips?.('');
        };
    }, []);

    React.useEffect(() => {
        return () => {
            set('currentSpeciality', undefined);
            set('speciality', []);
        };
    }, []);

    if (loading) {
        return (
            <div className={s.module}>
                <div className={s.wrap}>
                    <Spin className={s.loading} />
                </div>
            </div>
        );
    }

    const getTableUseData = (serverData?: TKlarityServiceServerTableItem[]): TKlarityServiceUiTableItem[] => {
        const ret: TKlarityServiceUiTableItem[] = [];
        const allSpeIds: number[] = [];
        if (!allStates || allStates.length === 0) {
            return [];
        }
        serverData?.forEach((item: TKlarityServiceServerTableItem) => {
            if (!allSpeIds.includes(item.serviceSpecialtyId)) {
                allSpeIds.push(item.serviceSpecialtyId);
            }
        });
        allSpeIds.forEach((speId: number) => {
            const speData: TKlarityServiceServerTableItem[] =
                serverData?.filter((item: TKlarityServiceServerTableItem) => item.serviceSpecialtyId === speId) || [];
            speData.sort((a, b) => {
                return a.state && b.state ? a.state.localeCompare(b.state) : 0;
            });
            if (speData.length > 0) {
                const firstData = speData[0];
                const add: TKlarityServiceUiTableItem = {
                    serviceSpecialtyName: firstData.serviceSpecialtyName,
                    serviceSpecialtyId: firstData.serviceSpecialtyId,
                    serviceTypeInfo: [],
                };
                speData.forEach((item: TKlarityServiceServerTableItem, inx) => {
                    const state = (allStates as SettingEnum[])?.find(
                        (st: SettingEnum) => st.dictKey === item.state || st.content === item.state,
                    );
                    const contactType: EContactType[] = [];
                    if (item.inPerson) {
                        contactType.push(EContactType.IN_PERSON);
                    }
                    if (item.teleHealth) {
                        contactType.push(EContactType.TELE_HEALTH);
                    }
                    //is save spe
                    const addData: KlarityServiceTypeInfo = {
                        state: state as ServerMeta,
                        serviceId: item.serviceId,
                        serviceType: item.serviceType,
                        customizedServiceName: item.customizedServiceName || '',
                        earning: item.earning,
                        patientCost: item.patientCost,
                        contactType,
                        groupAndLimitationId: item.groupAndLimitationId,
                        qtyPatientGroup: item.qtyPatientGroup,
                        qtyLimitation: item.qtyLimitation,
                        accpet: undefined,
                        limitations: undefined,
                        rowId: inx,
                        allPatientGroup: item.allPatientGroup,
                        avaPriceInsight: item.avaPriceInsight,
                        klarityTemplate: item.klarityTemplate,
                        intakeFormFlag: item.intakeFormFlag,
                        allowControlledMedRefill: item.allowControlledMedRefill,
                    };
                    if (isKiwiUser) {
                        addData.insurances = item.insurances;
                        addData.priorAuthorizationSupport = item.priorAuthorizationSupport;
                        addData.superBillSupport = item.superBillSupport;
                    }
                    add.serviceTypeInfo!.push(addData);
                });
                ret.push(add);
            }
        });
        return ret.filter((item) => item.serviceSpecialtyName !== LA_WILD_FIRE_SPECIALTY_NAME);
    };

    const fetchEditDetailAndShowModal = async (currentEditService: TKlarityServiceUiTableItem) => {
        setModalMode(EModalMode.CONFIG_SERVICE);
        if (!isOps && !isReviewStep && !isServiceSetting) {
            setShowSelectLayer(true);
        } else {
            setShowSelectModal(true);
        }
        setFetchingEdit(true);
        setIsEdit(true);
        let templateDetailResult: any;
        if (isOps && providerId) {
            templateDetailResult = await getOpsSpecialityTemplateDetail(currentEditService.serviceSpecialtyId);
        } else {
            templateDetailResult = await getSpecialityTemplateDetail(currentEditService.serviceSpecialtyId);
        }
        if (!templateDetailResult.error) {
            const configItem = templateDetailResult?.data?.data;
            setEditingData([configItem]);
        }
        let detailDataResult: any;
        if (isOps && providerId) {
            detailDataResult = await getOpsProviderSpecialtyDetail(currentEditService.serviceSpecialtyId, providerId);
        } else {
            detailDataResult = await getProviderSpecialtyDetail(currentEditService.serviceSpecialtyId);
        }
        if (!detailDataResult.error) {
            setEditSpecialityValue(detailDataResult?.data?.data);
        }
        setFetchingEdit(false);
    };

    return (
        <div className={`${showSelectLayer ? '' : s.module}`}>
            <Modal
                destroyOnClose
                width={1000}
                className={commonS.modalFixHeightWrap}
                open={showProgramNoteModal}
                onCancel={() => {
                    setConfigingProgramId();
                    setShowProgramNoteModal(false);
                }}
                footer={null}
            >
                <ServiceLayer
                    isPPVOPS={isPPVOPS}
                    provider={provider}
                    allPrograms={allPrograms}
                    refetchProgram={refetchProgram}
                    serverIdStateMap={serverIdStateMap}
                    setServerIdStateMap={setServerIdStateMap}
                    uniprofileInsuranceData={uniprofileInsuranceData}
                    hideFooter
                    targetSpecialty={targetSpecialtyHasConfig ? undefined : targetSpecialty}
                    isReviewStep={isReviewStep}
                    isEdit={false}
                    fetchingEdit={fetchingEdit}
                    onCancel={(hasChange: boolean) => {
                        setEditingData([]);
                        setShowSelectModal(false);
                        setShowSelectLayer(false);
                        setEditingData([]);
                        setEditSpecialityValue(undefined);
                        setIsEdit(false);
                        refetchTemplate();
                        if (hasChange) {
                            setDisallowNext?.(false);
                            setDisallowNextTips?.('');
                            refetchTableData();
                        }
                    }}
                    onSelected={() => {}}
                    recommendData={templateDataFiltered?.recommend}
                    otherData={templateDataFiltered?.other}
                    editData={editingData}
                    mode={EModalMode.CONFIG_PROGRAM_NOTE}
                    allowStatesForService={licenseStates}
                    editingValue={editSpecialityValue}
                    showEditButtons={showEditButtons}
                    isOps={isOps}
                    providerId={providerId}
                    addressList={addressList}
                    onBack={() => {
                        setShowSelectLayer(false);
                    }}
                />
            </Modal>
            <div className={`${showSelectLayer ? '' : s.wrap}`}>
                {showLanding && (
                    <div className={s.landingWrap}>
                        <Landing onClickReview={onClickReview} />
                    </div>
                )}
                {/* ops logic */}
                {!showLanding && !showSelectLayer && (
                    <ServiceTable
                        isServiceSetting={isServiceSetting}
                        isKiwiUser={isKiwiUser}
                        showProgramConfigNote={() => {
                            setShowProgramNoteModal(true);
                        }}
                        onClickAdd={() => {
                            if (isServiceSetting) {
                                setModalMode(EModalMode.SELECT_SPECIALTY);
                                setShowSelectLayer(true);
                            } else {
                                setIsEdit(false);
                                setModalMode(EModalMode.SELECT_SPECIALTY);
                                if (!isOps && !isReviewStep && !isKiwiUser) {
                                    setShowSelectLayer(true);
                                } else {
                                    setShowSelectModal(true);
                                }
                            }
                        }}
                        onClickEdit={(currentEditService: TKlarityServiceUiTableItem) => {
                            fetchEditDetailAndShowModal(currentEditService);
                        }}
                        loading={tableDataLoading}
                        data={getTableUseData(tableData || [])}
                        showEditButtons={showEditButtons}
                        isOps={isOps}
                        providerId={providerId}
                        showSyncButton={showSyncButton}
                        onClickSync={onClickSync}
                        licenseStates={licenseStates}
                        onClickConfigProgram={(program: TKlarityProgramItem) => {
                            if (!isOps) {
                                setConfigProgramFromTable(true);
                                setConfigingProgramId(`${program.id}`);
                                setModalMode(EModalMode.CONFIG_PROGRAM_NOTE);
                                setShowSelectLayer(true);
                            }
                        }}
                        refetchTableData={refetchTableData}
                    />
                )}
                {
                    // 在Service setting页面，如果最后显示table，则显示ServiceLayer先让provider进行设置
                    !showLanding && showSelectLayer && (
                        <ServiceLayer
                            isPPVOPS={isPPVOPS}
                            fullWidthFooter={fullWidthFooter}
                            isServiceSetting={isServiceSetting}
                            setIsSpecialtyiesEnd={setIsSpecialtyiesEnd}
                            hideAvaTip={hideAvaTip}
                            onSetCurrentStep={setCurrentStep}
                            nextBtnText={layerNextBtnText}
                            footWrapCalss={layerFootWrapClass}
                            provider={provider}
                            allPrograms={allPrograms}
                            refetchProgram={refetchProgram}
                            serverIdStateMap={serverIdStateMap}
                            setServerIdStateMap={setServerIdStateMap}
                            uniprofileInsuranceData={uniprofileInsuranceData}
                            isKiwiUser={isKiwiUser}
                            targetSpecialty={targetSpecialtyHasConfig ? undefined : targetSpecialty}
                            isReviewStep={isReviewStep}
                            isEdit={isEdit}
                            fetchingEdit={fetchingEdit}
                            onCancel={(hasChange: boolean) => {
                                setEditingData([]);
                                setShowSelectModal(false);
                                setShowSelectLayer(false);
                                setEditingData([]);
                                setEditSpecialityValue(undefined);
                                setIsEdit(false);
                                refetchTemplate();
                                if (hasChange) {
                                    setDisallowNext?.(false);
                                    setDisallowNextTips?.('');
                                    onSaveSuccessfully?.();
                                    refetchTableData();
                                }
                            }}
                            onSelected={() => {}}
                            recommendData={templateDataFiltered?.recommend}
                            otherData={templateDataFiltered?.other}
                            editData={editingData}
                            mode={modalMode}
                            allowStatesForService={licenseStates}
                            editingValue={editSpecialityValue}
                            showEditButtons={showEditButtons}
                            isOps={isOps}
                            providerId={providerId}
                            addressList={addressList}
                            onBack={() => {
                                if (typeof onLayerBackClick === 'function') {
                                    onLayerBackClick();
                                } else {
                                    setShowSelectLayer(false);
                                }
                            }}
                        />
                    )
                }
                <ServiceModal
                    uniprofileInsuranceData={uniprofileInsuranceData}
                    provider={provider}
                    allPrograms={allPrograms}
                    refetchProgram={refetchProgram}
                    serverIdStateMap={serverIdStateMap}
                    setServerIdStateMap={setServerIdStateMap}
                    isKiwiUser={isKiwiUser}
                    useForSpecialtySelectModal={!isOps && isKiwiUser}
                    isEdit={isEdit}
                    fetchingEdit={fetchingEdit}
                    show={showSelectModal}
                    onSpecialtySelectSubmit={(selectedSpecialtyServices: KlarityService[]) => {
                        setModalMode(EModalMode.CONFIG_SERVICE);
                        setShowSelectModal(false);
                        setShowSelectLayer(true);
                        setEditingData(selectedSpecialtyServices);
                        set(
                            'speciality',
                            selectedSpecialtyServices?.map((item) => item.specialtyName),
                        );
                    }}
                    onCancel={(hasChange: boolean) => {
                        setEditingData([]);
                        setShowSelectModal(false);
                        setEditingData([]);
                        setEditSpecialityValue(undefined);
                        setIsEdit(false);
                        refetchTemplate();
                        if (hasChange) {
                            setDisallowNext?.(false);
                            setDisallowNextTips?.('');
                            refetchTableData();
                        }
                    }}
                    onSelected={() => {}}
                    recommendData={templateDataFiltered?.recommend}
                    otherData={templateDataFiltered?.other}
                    editData={editingData}
                    mode={modalMode}
                    allowStatesForService={licenseStates}
                    editingValue={editSpecialityValue}
                    showEditButtons={showEditButtons}
                    isOps={isOps}
                    providerId={providerId}
                    addressList={addressList}
                    isPPVOPS={isPPVOPS}
                />
            </div>
        </div>
    );
};

export default KlarityServices;
